"use strict";
/**
 *
 * You can implement *Disposable* resources and use them with a *using()* or *usingAsync()* syntax.
 *
 * Usage example:
 *
 * ```ts
 * class Resource implements Disposable{
 *       dispose(){
 *           // cleanup logics
 *      }
 * }
 *
 *
 * using(new Resource(), (resource)=>{
 *      // do something with the resource
 * })
 *
 * usingAsync(new Resource(), async (resource)=>{
 *      // do something with the resource, allows awaiting promises
 * })
 * ```
 */
/** */
Object.defineProperty(exports, "__esModule", { value: true });
exports.usingAsync = exports.using = void 0;
const tslib_1 = require("tslib");
/**
 * Method that accepts an Disposable resource that will be disposed after the callback
 * @param {Disposable} resource The resource that is used in the callback and will be disposed afterwards
 * @param {function} callback The callback that will be executed synchrounously before the resource will be disposed
 */
const using = (resource, callback) => {
    try {
        return callback(resource);
    }
    finally {
        resource.dispose();
    }
};
exports.using = using;
/**
 * Method that accepts an Disposable resource that will be disposed after the callback
 * @param {Disposable} resource The resource that is used in the callback and will be disposed afterwards
 * @param {function} callback The callback that will be executed asynchrounously before the resource will be disposed
 */
const usingAsync = (resource, callback) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    try {
        return yield callback(resource);
    }
    finally {
        const disposeResult = resource.dispose();
        if (disposeResult instanceof Promise) {
            yield disposeResult;
        }
    }
});
exports.usingAsync = usingAsync;
//# sourceMappingURL=disposable.js.map